import { AvailableColumn } from "../models/AvailableColumn";
import { Rule } from "../models/Rule";
import { AvailableColumnServiceBase } from "./AvailableColumnServiceBase";



export class AvailableColumnsService extends AvailableColumnServiceBase {

    static readonly injectableKey = AvailableColumnServiceBase.serviceKeyPrefix;

    get injectableKey(): string {
        return `${(this.constructor as typeof AvailableColumnsService).injectableKey}_${this.version}`;
    }

    constructor() {
        super("1.0.0");
    }

    protected calculateAvailableColumnsForRule(rule: Rule, rules: Array<Rule>, sourceColumns: Array<AvailableColumn>): Array<AvailableColumn> {

        if (rule == null) throw Error("rule are required");
        if (rules == null) throw Error("rules are required");

        const indexOfRule = rules.findIndex(x => x.id === rule.id);
        if (indexOfRule < 0) throw new Error("Rule must be contained within rules to calculate available columns");

        let availableColumnsForRule = [...(sourceColumns || [])];
        rules.forEach((rule: Rule, index: number) => {

            switch (rule._type) {
                case "add_column":
                    const expectedAddColumnNameKey = "columnName";
                    const addColumnResult = this.tryGetValueAtKey(rule.configuration, expectedAddColumnNameKey, rule._type);
                    if (!addColumnResult.keyExists) break;
                    if (indexOfRule > index && addColumnResult.value != null)
                        this.addAvailableColumn(availableColumnsForRule, new AvailableColumn(addColumnResult.value, addColumnResult.value));
                    break;
                case "delete_column":
                    const expectedRemoveColumnNameKey = "columnName";
                    const deleteColumnResult = this.tryGetValueAtKey(rule.configuration, expectedRemoveColumnNameKey, rule._type);
                    if (!deleteColumnResult.keyExists) break;
                    if (indexOfRule > index) availableColumnsForRule = availableColumnsForRule.filter(x => x.value !== deleteColumnResult.value);
                    break;
                case "mapping":
                    const expectedColumnsArrayKey = "columns";
                    const columnsResult = this.tryGetValueAtKey(rule.configuration, expectedColumnsArrayKey, rule._type);
                    if (!columnsResult.keyExists || !Array.isArray(columnsResult.value)) break;
                    columnsResult.value.forEach(((item: any) => {
                        const expectedDestinationColumnKey = "destinationColumn";
                        const destinationColumnResult = this.tryGetValueAtKey(item, expectedDestinationColumnKey, rule._type);
                        if (!destinationColumnResult.keyExists) return;
                        if (indexOfRule > index && destinationColumnResult.value != null) 
                            this.addAvailableColumn(availableColumnsForRule, new AvailableColumn(destinationColumnResult.value, destinationColumnResult.value));
                    }))
                    break;
            }

        });

        return availableColumnsForRule;

    }

    private addAvailableColumn(list: Array<AvailableColumn>, column: AvailableColumn): void {
        const exists = list.some(c => c.value === column.value && c.label === column.label);
        if (!exists) list.push(column);
    }

    private tryGetValueAtKey(configuration: any, key: string, type: string): { keyExists: boolean, value: any } {
        const keyExists = configuration && Object.keys(configuration).findIndex(x => x == key) !== -1;
        let value = undefined;
        if (!keyExists) console.warn(`Missing expected key: ${key} on rule: ${type}!`)
        else {
            const rawValue = configuration[key];
            value = rawValue === '' ? null : rawValue;
        }
        return { keyExists, value };
    }




}